import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BlogCategoryForm from "./BlogCategoryForm";
import { createBlog } from "../../api/BlogCategoryService";
import { addSeo } from "../../api/SeoService";

const BlogCategoryadd = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      setErrors({});

      const categoryPayload = {
        name: values.name,
        description: values.description,
        status: values.status,
      };

      const categoryRes = await createBlog(categoryPayload);
      const categoryData = categoryRes?.data || categoryRes;
      const categoryId = categoryData?._id || categoryData?.id;

      if (!categoryId) {
        setErrors(
          categoryRes?.error ||
            categoryRes?.data ||
            { message: "Blog category id not found" },
        );
        return;
      }

      const seoPayload = {
        referenceId: String(categoryId),
        referenceType: "BlogCategory",
        metaTitle: values.metaTitle || "",
        metaDescription: values.metaDescription || "",
        metaKeywords: Array.isArray(values.metaKeywords)
          ? values.metaKeywords
          : (values.metaKeywords || "")
              .split(",")
              .map((item) => item.trim())
              .filter(Boolean),
        status: values.status || "",
        metaImage:
          typeof values.metaImage === "string"
            ? values.metaImage
            : values.metaImage
              ? values.metaImage
              : "",
      };

      const seoRes = await addSeo(seoPayload);
      const seoError =
        seoRes?.error || seoRes?.data?.error || seoRes?.data?.errors || seoRes?.errors;

      if (seoError || seoRes?.success === false) {
        setErrors(seoError || seoRes?.data || seoRes || { message: "Please fix SEO validation errors" });
        return;
      }

      navigate("/blogcategory");
    } catch (error) {
      console.error(error);

      const responseData = error?.response?.data;
      const responseErrors =
        responseData?.error || responseData?.errors || responseData || error?.error || { message: error?.message || "Submit failed" };

      setErrors({
        ...(typeof responseErrors === "object" && responseErrors),
        message:
          responseData?.message ||
          responseErrors?.message ||
          error?.message ||
          "Submit failed",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <BlogCategoryForm
      onSubmit={handleSubmit}
      loading={loading}
      errors={errors}
      onCancel={() => navigate("/blogcategory")}
    />
  );
};

export default BlogCategoryadd;
